/** The human-readable part of an error thrown by a Supabase call, for notifications. */
export const errorMessageOf = (error: unknown): string => {
  if (!error) return '';
  if (typeof error === 'string') return error;
  const e = error as { message?: unknown; details?: unknown; code?: unknown };
  const parts = [e.message, e.details].filter((p): p is string => typeof p === 'string' && p.trim() !== '');
  const text = parts.join(' ');
  return typeof e.code === 'string' && e.code && !text.includes(e.code) ? `${text} (${e.code})`.trim() : text;
};
